export const configPersonalInfos = ({ party = {}, strings = {} }) => ({
  fields: [
    {
      name: 'gender',
      type: 'selection',
      label: strings['party.edit.field.gender.label'] || 'Gender',
      options: [
        { value: 'male', text: 'M.' },
        { value: 'female', text: 'Mme.' },
        { value: '', text: '' }
      ]
    },
    {
      name: 'first_name',
      type: 'string',
      label: strings['party.edit.field.first_name.label'] || 'First Name'
    },
    // Not yet supported by Coog API
    // { name: 'birth_name', type: 'string', label: 'Birth name' },
    { name: 'name', type: 'string', label: strings['party.edit.field.name.label'] || 'Name' },
    {
      name: 'birth_date',
      type: 'date',
      placeholder: 'YYYY-MM-DD',
      label: strings['party.edit.field.birth_name.label'] || 'Birth Name'
    }
    // Not yet supported by Coog API
    // { name: 'birth_order', type: 'number', label: 'Birth order' }
  ],
  initialValues: {
    first_name: party.first_name,
    name: party.name,
    gender: party.gender,
    // Not yet supported by Coog API
    // birth_name: party.birth_name,
    birth_date: party.birth_date
    // Not yet supported by Coog API
    // birth_order: party.birth_order
  },
  type: 'object'
});

export const configLegalInfos = ({ party = {}, strings = {} }) => ({
  fields: [
    { name: 'name', type: 'string', label: strings['party.edit.field.name.label'] || 'Name' }
  ],
  initialValues: {
    name: party.name
  },
  type: 'object'
});

export const configContacts = ({ party = {}, strings = {} }) => {
  const getInitialValues = () => {
    const { contact_mechanisms: contactMechanisms } = party;
    return Array.isArray(contactMechanisms)
      ? contactMechanisms.map(contact => ({
          id: contact.id,
          value: contact.value,
          type: contact.type
        }))
      : [];
  };
  return {
    fields: [
      {
        name: 'type',
        type: 'selection',
        label: strings['party.edit.field.type.label'] || 'Type',
        options: [
          {
            value: 'phone',
            text: strings['party.edit.field.phone.label'] || 'Phone'
          },
          {
            value: 'email',
            text: strings['party.edit.field.email.label'] || 'Email'
          },
          {
            value: 'mobile',
            text: strings['party.edit.field.mobile.label'] || 'Mobile'
          }
        ],
        default: 'mobile',
        grow: '0'
      },
      {
        name: 'value',
        type: 'string',
        label: strings['party.edit.field.value.label'] || 'Value',
        grow: '1'
      }
    ],
    initialValues: { contacts: getInitialValues() },
    type: 'array'
  };
};

export const configAddresses = ({ party = {}, strings = {} }) => {
  const getInitialValues = () => {
    const { addresses } = party;
    return Array.isArray(addresses)
      ? addresses.map(address => ({
          id: address.id,
          city: address.city,
          street: address.street,
          zip: address.zip
        }))
      : [];
  };
  return {
    fields: [
      {
        name: 'street',
        type: 'string',
        label: strings['party.edit.block.one_line_street.label'] || 'Street',
        grow: '2'
      },
      {
        name: 'zip',
        type: 'string',
        label: strings['party.edit.block.zip.label'] || 'Zip',
        grow: '0'
      },
      {
        name: 'city',
        type: 'string',
        label: strings['party.edit.block.city.label'] || 'City',
        grow: '1'
      }
    ],
    initialValues: { addresses: getInitialValues() },
    type: 'array'
  };
};
